<div class="equipment-panel">
  <div class="equipment-panel__body">
    <div class="panel-header">
      <img src="assets/icon/icon-park_truck.svg" alt="" />
      <span class="title">{{ 'TOOLTIP.EQUIPMENT' | translate }}</span>
    </div>

    <label class="field">
      <span>{{ 'DONNEE_SUIVI_OP.DATE' | translate }}</span>
      <input type="date" [value]="dateValue()" (change)="setDate($any($event.target).value)" />
    </label>

    <label class="field">
      <span>{{ 'GLOBAL.SHIFT' | translate }}</span>
      <select (change)="setShift($any($event.target).value)">
        <option value="" [selected]="store.equipmentShift() === null">—</option>
        @for (option of shiftOptions; track option.value) {
          <option [value]="option.value" [selected]="option.value === store.equipmentShift()">
            {{ option.label | translate }}
          </option>
        }
      </select>
    </label>

    <p class="count">{{ store.equipments().length }} {{ 'DONNEE_SUIVI_OP.EQUIPEMENT' | translate }}</p>
  </div>
</div>
